import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Loader from '../../../../atoms/icons/loader';
import { ChartTimelineVariantShimmerIcon } from '../../../../atoms/material-icons';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import './moving-averages.m.css';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

const MovingAverages = (props) => {
  const [movingAveragesData, setMovingAveragesData] = useState({});
  const [filteredData, setFilteredData] = useState({});
  const [stockId, setStockId] = useState('');
  const [nseSelected, setNseSelected] = useState(false);
  const [bseSelected, setBseSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getMovingAveragesDataForQuery = async (stockId) => {
    const response = await fetch(`/next/feapi/stock/moving-averages/${stockId}`);
    return response.json();
  };

  const resultMovingAverageData = useQuery(
    'getMovingAveragesData',
    () => getMovingAveragesDataForQuery(stockId),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setMovingAveragesData(data.data);
        nseSelected ? setFilteredData(data?.data?.nse) : setFilteredData(data?.data?.bse);
      },
      enabled:
        initialLoading || (!!stockId && isWithinTradingHours(tradingHolidays, specialTradingDays)),
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getMovingAveragesData = async () => {
      setLoading(true);
      const stockId = fetchStockId();
      const response = await fetch(`/next/feapi/stock/moving-averages/${stockId}`);
      const data = await response.json();
      setMovingAveragesData(data?.data);
      setFilteredData(data?.data?.nse);
      setStockId(stockId);
      setLoading(false);
    };

    getMovingAveragesData();
    setNseSelected(true);
    setBseSelected(false);
  }, []);

  useEffect(() => {
    const stockId = fetchStockId();
    setStockId(stockId);

    if (resultMovingAverageData?.isSuccess) {
      setMovingAveragesData(resultMovingAverageData?.data?.data);
      nseSelected
        ? setFilteredData(resultMovingAverageData?.data?.data?.nse)
        : setFilteredData(resultMovingAverageData?.data?.data?.bse);
    }
  }, [resultMovingAverageData?.data?.data]);

  const nseClickHandler = () => {
    setFilteredData(movingAveragesData?.nse);
    setNseSelected(true);
    setBseSelected(false);
  };

  const bseClickHandler = () => {
    setFilteredData(movingAveragesData?.bse);
    setNseSelected(false);
    setBseSelected(true);
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="moving-avg-container">
      <div styleName="header-title-container">
        <ChartTimelineVariantShimmerIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">Moving Averages</h2>
      </div>
      <div styleName="btn-container">
        <button
          styleName={`btn-filter ${nseSelected ? 'selected' : ' '}`}
          onClick={nseClickHandler}
        >
          NSE
        </button>
        <button
          styleName={`btn-filter ${bseSelected ? 'selected' : ' '}`}
          onClick={bseClickHandler}
        >
          BSE
        </button>
      </div>
      {isEmpty(movingAveragesData) && isEmpty(filteredData) ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState />
          </div>
        </div>
      ) : (
        <>
          {!isEmpty(filteredData) && (
            <div styleName="total-returns-msg">
              <div>
                <span className="icon-ic_lightbulb" />
                <span>INSIGHTS</span>
              </div>
              <span>{filteredData?.msg}</span>
            </div>
          )}

          {loading ? (
            <div styleName="loading-container">
              <Loader />
            </div>
          ) : isEmpty(filteredData) ? (
            <div styleName="no-data-container-ext">
              <div styleName="no-data-container-int">
                <EmptyState />
              </div>
            </div>
          ) : (
            <div styleName="moving-averages-body">
              <div styleName="price-stats-time">
                {moment(filteredData?.date).format('MMM Do, hh:mm:ss')} | Current Price(Rs.){' '}
                {filteredData?.currentPrice}
              </div>

              <table>
                <tr>
                  <th>Days</th>
                  <th>Average</th>
                </tr>

                <tr>
                  <td styleName="days-text">5</td>
                  <td>{filteredData?.day5}</td>
                </tr>
                <tr>
                  <td styleName="days-text">20</td>
                  <td>{filteredData?.day20}</td>
                </tr>
                <tr>
                  <td styleName="days-text">50</td>
                  <td>{filteredData?.day50}</td>
                </tr>
                <tr>
                  <td styleName="days-text">100</td>
                  <td>{filteredData?.day100}</td>
                </tr>
                <tr>
                  <td styleName="days-text">200</td>
                  <td>{filteredData?.day200}</td>
                </tr>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MovingAverages;
